import React from 'react'
import styles from '../SustainbilitySection/SustainbilitySection.module.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
const SustainbilitySection = () => {
    const navigate = useNavigate();
    const settings = {
        dots: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        fade: true,
        vertical: false,
    };
    return (
      <section>
        <div className={styles.BackBtnDiv}>
          <div className={styles.backBtn} onClick={() => navigate(-1)}>
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.252011 8.20052L5.8383 14.6871C6.15713 15.0254 6.82754 15.1466 7.19124 14.759C7.55373 14.3848 7.55373 13.6604 7.19124 13.2729L3.08873 8.52662L17.0653 8.52662C17.5818 8.52662 18 8.06717 18 7.49988C18 6.9326 17.5817 6.47315 17.0653 6.47315L3.08873 6.47315L7.19 1.72555C7.55249 1.35132 7.57431 0.589615 7.19 0.239358C6.82751 -0.086909 6.16681 -0.098897 5.83706 0.323253L0.252011 6.79793C0.00955088 7.06428 -0.166247 7.75277 0.252011 8.1989V8.20052Z"
                fill="currentColor"
              />
            </svg>
            <h4>Back</h4>
          </div>
        </div>

        <div className={styles.heroSection}>
          <div className={styles.Slider_section}>
            <Slider {...settings}>
              <div className={styles.Img_div}>
                <img
                  src="Images/000.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/033.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/044.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/022.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/055.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/066.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
              <div className={styles.Img_div}>
                <img
                  src="Images/077.webp"
                  alt="carousel of happy people with healthy eyes on Deseyne® product packaging"
                loading="lazy" decoding="async" />
              </div>
            </Slider>
          </div>
          <div className={styles.content_section}>
            <div className={styles.tittle}>
              <div className={styles.bredcrumMain}>
                <div className={styles.bredcrum}>
                  <h5 className={styles.Rightheading}>Sustainability</h5>
                </div>
              </div>
              <div className={styles.subtitle}>
                <h1>Fostering the future</h1>
              </div>
              <p className={styles.titpara}>
                Building toward a smaller footprint
              </p>
              <div className={styles.description}>
                <p className={styles.desc}>
                  Sustainability begins with accountability. At Bruno Vision
                  Care, every step of our waste process is tracked and audited,
                  from storage to transport to disposal. As we expand, we are
                  working to reduce material use in manufacturing and set
                  recycling goals that exceed our overall waste reduction target
                  of 1% by 2026.
                </p>
                <p className={styles.desc}>
                  Our commitment extends across manufacturing, water
                  conservation, energy efficiency, and greenhouse gas reduction.
                  Bruno Vision Care is a young company, but we are embedding
                  sustainability into our evolution from the start. Our ambition
                  is clear: global growth, global sustainability, and innovation
                  that serves patients, practitioners, and the planet alike.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.trackingDiv}>
          <img src="Images/two-girls.webp" alt="two-girls" loading="lazy" decoding="async" />
        </div>
      </section>
    );
}

export default SustainbilitySection
